/* global experiments*/
import { mapState } from 'vuex';

export default {
  data() {
    return {
      experiments: {},
      placeholderImage: {
        url: '/images/my-account/default-picture.png',
        alt_text: 'Madison Reed Logo'
      }
    };
  },

  computed: {
    ...mapState('customer', ['cdata'])
  },

  methods: {
    trackEvent(eventName, properties) {
      properties = properties || {};
      properties.dig = this.cdata.dig;
      properties.dug = this.cdata.dug;
      properties.isIOS = this.cdata.isIOS;
      properties.sessionId = this.cdata.sessionId;
      properties.agent_id = this.cdata.agent_id;
      properties.postal_code = this.cdata.postalCode;

      if (this.cdata.user && this.cdata.user.id) {
        properties.user_id = this.cdata.user.id;
        if (this.cdata.user.email) {
          properties.email = this.cdata.email;
        }
      }

      var context = {
        location: this.cdata.locationContext
      };

      if (!properties.user_id) {
        context.anonymousId = this.cdata.dig;
      }

      window.analytics.track(eventName, properties, context);
    },

    trackMREvent(eventName, properties) {
      properties = properties || {};
      properties.eventName = eventName;
      this.trackEvent('MREvent', properties);
    },

    goToPath(path, newTab) {
      if (newTab) {
        window.open(path);
      } else {
        location.href = path;
      }
    },

    back() {
      window.history.back();
    }
  },

  mounted() {
    this.experiments = experiments;
  }
};